import React, { useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import OptionsTrading from './OptionsTrading';
import NormalTradingV1 from './NormalTradingV1';
import FutureTrading from './FutureTrading';
import GoldTrading from './GoldTrading';
import BestPerformer from './BestPerformer';
import NormalTradingV1Master from './NormalTradingV1Master';
import NormalTradingV1Sold from './NormalTradingV1Sold';
import TwoHourTrading from './TwoHourTrading';
import TradingLedgerPage from './TradingLedgerPage';
import LiveErrorBoundary from './LiveErrorBoundary';
import DegenDashboard from './degen/DegenDashboard';
import DegenDailyReport from './degen/DegenDailyReport';
import CncDegenDashboard from './degen/CncDegenDashboard';
import AppShell from './AppShell';
import ScreenMaster from './ScreenMaster';
import ScreenGate from './ScreenGate';
import { ScreenMasterProvider } from './ScreenMasterContext';
import { ThemeProvider } from './ThemeContext';
import './theme.css';
import './App.css';

/** HashRouter app — fix phone / deep links like /FutureTrading → /#/FutureTrading */
function HashDeepLinkFix() {
  useEffect(() => {
    try {
      const { pathname, search, hash } = window.location;
      if (hash && hash !== '#' && hash !== '#/') return;
      if (!pathname || pathname === '/') return;
      const known = [
        '/FutureTrading', '/NormalTrading', '/GoldTrading', '/BestPerformer', '/ScreenMaster',
        '/TwoHourTrading', '/DegenDashboard', '/CncDegenDashboard', '/Report', '/ledger'
      ];
      if (!known.some((k) => pathname === k || pathname.startsWith(`${k}/`))) return;
      window.location.replace(`/#${pathname}${search || ''}`);
    } catch { /* ignore */ }
  }, []);
  return null;
}

const App = () => (
  <ThemeProvider>
    <HashDeepLinkFix />
    <HashRouter>
      <ScreenMasterProvider>
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/ScreenMaster" element={<ScreenMaster />} />
            <Route path="/" element={<ScreenGate screenId="options" title="Options Trading"><OptionsTrading /></ScreenGate>} />
            <Route path="/NormalTrading" element={<ScreenGate screenId="normal-v1" title="Normal Trading V1"><LiveErrorBoundary title="Normal Trading V1"><NormalTradingV1 /></LiveErrorBoundary></ScreenGate>} />
            <Route path="/NormalTrading/Master" element={<ScreenGate screenId="normal-v1" title="V1 Master"><LiveErrorBoundary title="V1 Master"><NormalTradingV1Master /></LiveErrorBoundary></ScreenGate>} />
            <Route path="/NormalTrading/Sold" element={<ScreenGate screenId="normal-v1" title="Sold Today"><LiveErrorBoundary title="Sold Today"><NormalTradingV1Sold /></LiveErrorBoundary></ScreenGate>} />
            <Route path="/NormalTrading/Testing" element={<Navigate to="/NormalTrading" replace />} />
            <Route path="/NormalTrading/Testing/Master" element={<Navigate to="/NormalTrading/Master" replace />} />
            <Route path="/NormalTradingV1" element={<Navigate to="/NormalTrading" replace />} />
            <Route path="/TwoHourTrading" element={<ScreenGate screenId="twohour" title="2 Hour Trading"><TwoHourTrading /></ScreenGate>} />
            <Route path="/DegenDashboard" element={<ScreenGate screenId="degen" title="Degen Dashboard"><DegenDashboard /></ScreenGate>} />
            <Route path="/DegenDashboard/Report" element={<ScreenGate screenId="report" title="Daily Report"><DegenDailyReport /></ScreenGate>} />
            <Route path="/Report" element={<ScreenGate screenId="report" title="Daily Report"><DegenDailyReport /></ScreenGate>} />
            <Route path="/degen/report" element={<Navigate to="/Report" replace />} />
            <Route path="/CncDegenDashboard" element={<ScreenGate screenId="cnc-degen" title="CNC Delivery"><CncDegenDashboard /></ScreenGate>} />
            <Route path="/cnc-degen" element={<Navigate to="/CncDegenDashboard" replace />} />
            <Route path="/degen" element={<Navigate to="/DegenDashboard" replace />} />
            <Route path="/ledger" element={<Navigate to="/ledger/normal" replace />} />
            <Route path="/ledger/:mode" element={<ScreenGate screenId="ledger" title="Trading Ledger"><TradingLedgerPage /></ScreenGate>} />
            <Route path="/FutureTrading" element={<ScreenGate screenId="future" title="Future Trading"><LiveErrorBoundary title="Future Trading"><FutureTrading /></LiveErrorBoundary></ScreenGate>} />
            <Route path="/GoldTrading" element={<ScreenGate screenId="gold" title="Gold Trading"><LiveErrorBoundary title="Gold Trading"><GoldTrading /></LiveErrorBoundary></ScreenGate>} />
            <Route path="/BestPerformer" element={<ScreenGate screenId="best-performer" title="Best Performer"><LiveErrorBoundary title="Best Performer"><BestPerformer /></LiveErrorBoundary></ScreenGate>} />
          </Route>
        </Routes>
      </ScreenMasterProvider>
    </HashRouter>
  </ThemeProvider>
);

export default App;
